
(function ($) {
  // map to store init state for each selector
  const owlState = {};

  // list of sliders to initialize with default options (selector => options)
  const owlConfigs = {
    '.info-slide': {
      loop: true,
      margin: 0,
      items: 1,
      nav: false,
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 3500,
      mouseDrag: false,
      touchDrag: false,
      pullDrag: false,
      freeDrag: false
    },
    '.brands-slide': {
      loop: true,
      margin: 15,
      nav: false,
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 3000,
      responsive: {
        0:   { items: 1 },
        576: { items: 2 },
        768: { items: 4 },
        991: { items: 5 }
      }
    },
    '.leasing-slide': {
      loop: false,
      margin: 15,
      nav: false,
      autoplay: false,
      // autoHeight: true,
      responsive: {
        0:   { items: 1 },
        576: { items: 3 },
        768: { items: 4 }
      }
    },
    '.cc-hp-banner .logos-slide': {
      loop: true,
      margin: 15,
      nav: false,
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 3000,
      responsive: {
        0:   { items: 1 },
        600: { items: 3 },
        768: { items: 3 },
        1400:{ items: 8 }
      }
    },
    '.cc-col-slide': {
      loop: true,
      margin: 15,
      nav: false,
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 3000,
      responsive: {
        0:   { items: 1 },
        576: { items: 2 },
        768: { items: 3 },
        991: { items: 4 }
      }
    },
    '.cc-collections-tab-slider .product-item': {
      loop: true,
      nav: false,
      autoplay: false,
      autoplayHoverPause: true,
      autoplayTimeout: 3000,
      items: 4,
      responsive: {
        0:   { items: 1, dots: true },
        769: { items: 1 },
        1400:{ items: 4 }
      }
    },
    // cc-icons slider: mobile-only behavior will be handled in init logic
    '.cc-icons .inner': {
      loop: true,
      margin: 15,
      nav: false,
      dots: true,
      autoplay: true,
      autoplayHoverPause: true,
      autoplayTimeout: 3000,
      responsive: {
        0:   { items: 1 },
        576: { items: 2 },
        768: { items: 3 },
        1200:{ items: 5 }
      }
    },
    // '.cc-prod-banner-marketing .cc-content-grid': {
    //   loop: true,
    //   margin: 15,
    //   nav: false,
    //   dots: true,
    //   autoplay: true,
    //   autoplayHoverPause: true,
    //   autoplayTimeout: 3000,
    //   items: 1
    // }
  };

  // Utility: safely init one selector (can match multiple elements)
  function initSelector(selector, options, forceReinit) {
    $(selector).each(function (index, el) {
      const $el = $(el);
      const id = selector + '::' + (index || 0);

      // if it's already an owl instance and not forced, skip
      if ($el.hasClass('owl-loaded') && !forceReinit) {
        // refresh to ensure layout is correct after load/resize
        try { $el.trigger('refresh.owl.carousel'); } catch (e) {}
        return;
      }

      // destroy prior instance if any (clean state)
      try {
        $el.trigger('destroy.owl.carousel');
        $el.removeClass('owl-loaded owl-hidden').find('.owl-stage-outer').children().unwrap();
      } catch (e) {}

      // If selector is cc-icons .inner and you intend mobile-only, check width
      if (selector === '.cc-icons .inner') {
        // change this condition to control mobile-only behavior
        // use < 769 for mobile-only, use true for always-on
        if ($(window).width() >= 769) {
          // do not init on desktop: leave plain markup
          owlState[id] = false;
          return;
        }
      }

      // Final init
      try {
        $el.owlCarousel(options);
        owlState[id] = true;
        console.info('Owl initialized:', selector, 'index:', index);
      } catch (err) {
        console.error('Owl init failed for', selector, err);
      }
    });
  }

  // Initialize all configured selectors
  function initAllOwl(forceReinit) {
    // fallback: ensure jQuery + owl exist
    if (typeof $ === 'undefined' || typeof $.fn.owlCarousel !== 'function') {
      console.error('jQuery or Owl Carousel missing. Make sure both are loaded before main.js');
      return;
    }

    // iterate and init
    Object.keys(owlConfigs).forEach(function (sel) {
      initSelector(sel, owlConfigs[sel], !!forceReinit);
    });
  }

  // When DOM ready, we call initAllOwl() — but the mobile slider may need window load for images
  $(document).ready(function () {
    // init the typical sliders that don't rely on image dimensions
    // brands, banners, leasing, col-slide etc. — safe to init now
    ['.info-slide', '.brands-slide', '.leasing-slide', '.cc-hp-banner .logos-slide', '.cc-col-slide', '.cc-collections-tab-slider .product-item'].forEach(function(s) {
      if (owlConfigs[s]) initSelector(s, owlConfigs[s]);
    });
  });

  // On window load (images/fonts ready) initialize everything else and refresh
  $(window).on('load', function () {
    initAllOwl(true); // force reinit to ensure proper sizes
    // extra refresh for known problem sliders
    try {
      $('.cc-icons .inner').trigger('refresh.owl.carousel');
      $('.brands-slide').trigger('refresh.owl.carousel');
    } catch (e) {}
  });

  // On resize, debounce and re-evaluate mobile-only sliders
  let resizeTimer = null;
  // $(window).on('resize', function () {
  //   clearTimeout(resizeTimer);
  //   resizeTimer = setTimeout(function () {
  //     // For safety, re-init all but prevent flicker — pass forceReinit=false
  //     // initAllOwl(false);

  //     // For cc-icons, if previously not init and now <769, init it; if previously init and now >=769 destroy it
  //     $('.cc-icons .inner').each(function(i, el) {
  //       const $el = $(el);
  //       if ($(window).width() < 769) {
  //         if (!$el.hasClass('owl-loaded')) initSelector('.cc-icons .inner', owlConfigs['.cc-icons .inner'], true);
  //       } else {
  //         if ($el.hasClass('owl-loaded')) {
  //           try {
  //             $el.trigger('destroy.owl.carousel');
  //             $el.removeClass('owl-loaded owl-hidden').find('.owl-stage-outer').children().unwrap();
  //             console.info('Destroyed cc-icons for desktop');
  //           } catch (e) { console.warn('Destroy cc-icons failed', e); }
  //         }
  //       }
  //     });
  //   }, 150);
  // });

  $(window).on('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {

    const isMobile = window.innerWidth < 769;
    const $icons = $('.cc-icons .inner');

    $icons.each(function () {
      const $el = $(this);

      if (isMobile && !$el.hasClass('owl-loaded')) {
        $el.owlCarousel(owlConfigs['.cc-icons .inner']);
      }

      if (!isMobile && $el.hasClass('owl-loaded')) {
        $el.trigger('destroy.owl.carousel');
        $el.removeClass('owl-loaded');
      }
    });

  }, 250);
});


  // Optional: expose a global reinit helper for manual debugging
  window.reinitAllOwl = function () {
    initAllOwl(true);
    console.info('reinitAllOwl called');
  };

})(jQuery);


//*************************************************** old main.js code***************************************

// var $ = jQuery;

// jQuery(document).ready(function ($) {
//   owl_slider();
//   playBtn();
//   menuOpen();

// });

//  jQuery(window).on("load", function ($) {
//     if (jQuery(window).width() < 769){
//       jQuery(".brands-slide").trigger("refresh.owl.carousel");
//     }
    
// });
// function playBtn() {
//   var play = $(".cc-prod-banner .img-holder img");
//   var cont = $(".cc-prod-banner .fvideo .inner");

//   play.click(function () {
//     cont.addClass("play");
//   });
// }
// function menuOpen() {
//   $(".cc-drawer .header__icon").click(function () {
//     $("html").toggleClass("drawer-open");
//   });
// }
// function cartTotal() {


// }

// var a='1,125';
// a=a.replace(/\,/g,''); // 1125, but a string, so convert it to number
// a=parseInt(a,10);
// function owl_slider() {
//   $(".info-slide").owlCarousel({
//     loop: true,
//     margin: 0,
//     items: 1,
//     nav: false,
//     autoplay: true,
//     autoplayHoverPause: true,
//     autoplayTimeout: 3500,
//     mouseDrag: false,
//     touchDrag: false,
//     pullDrag: false,
//     freeDrag: false,
//   });
  
//   $(".brands-slide").owlCarousel({
//     loop: true,
//     margin: 15,
//     nav: false,
//     autoplay: true,
//     autoplayHoverPause: true,
//     autoplayTimeout: 3000,
//     responsive: {
//       0: {
//         items: 1,
//       },
//       576: {
//         items: 2,
//       },
//       768: {
//         items: 4,
//       },
//       991: {
//         items: 5,
//       }
//     }
//   });
  
//   $(".leasing-slide").owlCarousel({
//     loop: false,
//     margin: 15,
//     nav: false,
//     autoplay: false,
//     autoHeight: true,
//     responsive: {
//       0: {
//         items: 1,
//       },
//       576: {
//         items: 3,
//       },
//       768: {
//         items: 4,
//       },
//     },
//   });
//   $(".cc-hp-banner .logos-slide").owlCarousel({
//     loop: true,
//     margin: 15,
//     nav: false,
//     autoplay: true,
//     autoplayHoverPause: true,
//     autoplayTimeout: 3000,
//     responsive: {
//       0: {
//         items: 1,
//       },
//       600: {
//         items: 3,
//       },
//       768: {
//         items: 3,
//       },
//       1400: {
//         items: 5,
//       },
//     },
//   });
//   $(".cc-col-slide").owlCarousel({
//     loop: true,
//     margin: 15,
//     nav: false,

//     autoplay: true,
//     autoplayHoverPause: true,
//     autoplayTimeout: 3000,
//     responsive: {
//       0: {
//         items: 1,
//       },
//       576: {
//         items: 2,
//       },
//       768: {
//         items: 3,
//       },
//       991: {
//         items: 4,
//       },
//     },
//   });

//   $('.specific-products li.nav-item button').on('click', function(){
//      var $owl = $('.cc-collections-tab-slider .product-item');

//     $owl.owlCarousel('destroy'); // Destroy old instance
//     $owl.owlCarousel({ // Reinitialize
//         loop: true,
//         nav: false,
//         autoplay: false,
//         autoplayHoverPause: true,
//         autoplayTimeout: 3000,
//          items: 4,
//         responsive: {
//           0: {
//             items: 1,
//             dots: true,
//           },
//           769: {
//             items: 1,
//           },
//           1400: {
//             items: 4,
//           },
//         }
//     });
//   })

//    $(".cc-collections-tab-slider .product-item").owlCarousel({
//     loop: true,
//     nav: false,
//     autoplay: false,
//     autoplayHoverPause: true,
//     autoplayTimeout: 3000,
//      items: 4,
//     responsive: {
//       0: {
//         items: 1,
//         dots: true,
//       },
//       769: {
//         items: 1,
//       },
//       1400: {
//         items: 4,
//       },
//     }
//   });

  

//   function checkScreenSize() {
//      if ($(window).width() < 769){
//        $(".cc-prod-banner-marketing .cc-content-grid").owlCarousel({
//         loop: true,
//         margin: 15,
//         nav: false,
//         dots: true,
//         autoplay: true,
//         autoplayHoverPause: true,
//         autoplayTimeout: 3000,
//        items: 1,
//       });
//       // cc icons 
//       $(".cc-icons .inner").owlCarousel({
//         loop: true,
//         margin: 15,
//         nav: false,
//         dots: true,
//         autoplay: true,
//         autoplayHoverPause: true,
//         autoplayTimeout: 3000,
//        items: 1,
//       });
//     }
//     else {
//         console.log("Screen size is above 767px");
//     }
//   }
//   checkScreenSize();
//  $(window).resize(function () {
//    checkScreenSize();
//   });
 
// }

// function matchHeight(className, winResize) {
//   if (winResize) {
//     $(className).each(function () {
//       $(this).height("auto");
//     });
//   }

//   var tallest = 0;
//   $(className).each(function () {
//     var height = $(this).height();
//     if (height > tallest) {
//       tallest = height;
//     }
//   });

//   // 2. Adjust the height of the elements
//   $(className).each(function () {
//     return $(this).height(tallest);
//   });
// }

// $(window).on("load", function () {
//   matchHeight(".leasing-slide .item", "false");
//   matchHeight(".item-mh", "true");
// });

// $(window).resize(function () {
//   matchHeight(".item-mh", "true");
// });

// //recent viewed app
// $(".rvp-container:empty").append( `<div class="rvp-section-wrap"><div class="rvp-title-wrap"><h3 style="font-size:48px">Recently viewed products</h3></div></div>`);
